// Regular training places of the Tri-Team. Only suggestions – any other place can be typed in.
export const PLACES = {
  hallenbad: 'Hallenbad Albgaubad',
  freibad: 'Freibad Albgaubad',
  lehrschwimmhalle: 'Lehrschwimmhalle Albgaubad',
  sporthalleEG: 'Sporthalle Eichendorff-Gymnasium (EG)',
  stadion: 'Hans-Bretz-Stadion',
  radTreff: 'Eingang Freibad Albgaubad',
  epplesee: 'Epplesee',
  groetzingen: 'Grötzinger Baggersee',
} as const;

/** All suggestions for the location field (datalist). */
export const LOCATION_SUGGESTIONS = [
  PLACES.hallenbad,
  PLACES.freibad,
  PLACES.lehrschwimmhalle,
  PLACES.sporthalleEG,
  PLACES.stadion,
  PLACES.epplesee,
  PLACES.groetzingen,
];
/** Suggestions for the meeting point field. */
export const MEETING_SUGGESTIONS = [PLACES.radTreff];

/**
 * Default place for a new event, derived from discipline, type and date (Monday swimming = Lehrschwimmhalle).
 * Returns empty strings when there is no typical place.
 */
export function suggestPlace(
  discipline: string,
  type: string,
  date: Date,
): { location: string; meeting_point: string } {
  if (discipline === 'swim') {
    return { location: date.getDay() === 1 ? PLACES.lehrschwimmhalle : PLACES.hallenbad, meeting_point: '' };
  }
  if (discipline === 'openwater') return { location: PLACES.epplesee, meeting_point: '' };
  if (discipline === 'strength' || discipline === 'fitness')
    return { location: PLACES.sporthalleEG, meeting_point: '' };
  if (discipline === 'run' && (type === 'interval' || type === 'tech' || type === 'test'))
    return { location: PLACES.stadion, meeting_point: '' };
  if (discipline === 'bike' || discipline === 'gravel' || discipline === 'mtb')
    return { location: '', meeting_point: PLACES.radTreff };
  return { location: '', meeting_point: '' };
}
